var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 258,
    viewBox: "0 0 250 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.223 107.923C110.076 107.923 90.5741 127.425 90.7272 151.419C90.7272 175.567 110.229 195.068 134.223 194.915C158.371 194.915 177.872 175.414 177.719 151.419C177.719 127.272 158.218 107.77 134.223 107.923ZM134.223 183.939C116.253 183.939 101.805 169.492 101.805 151.521C101.805 133.551 116.253 119.104 134.223 119.104C152.193 119.104 166.641 133.551 166.641 151.521C166.488 169.389 152.04 183.837 134.223 183.939Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.2404 189.504C75.2581 168.522 75.2581 134.47 96.2404 113.488C112.271 97.4576 135.907 93.6798 155.511 102.103C132.691 49.6222 96.1383 0 96.1383 0C96.1383 0 19.1523 102.614 19.1523 174.035C19.1523 216.102 53.6633 250 96.1383 250C124.88 250 149.13 234.327 162.403 211.099L153.98 201.501C134.631 209.108 111.862 205.126 96.2404 189.504Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.151 150.041C119.163 150.143 121.103 147.437 121.103 145.089C122.889 143.506 123.094 140.749 121.92 138.758C120.337 136.359 117.376 135.797 114.976 137.38C112.22 139.167 110.79 142.74 111.199 145.906C111.607 148.254 113.802 149.939 116.151 150.041Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.415 126.812C129.628 127.425 127.841 127.986 126.055 129.008C123.655 130.386 122.889 133.551 124.268 135.951C125.901 138.248 128.709 139.065 131.211 137.533C132.079 137.023 132.998 136.563 133.968 136.359C136.571 135.542 138.154 132.785 137.541 130.233C136.98 127.629 134.223 126.2 131.415 126.812Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M144.127 138.707C144.331 138.707 144.74 138.912 144.74 139.116C147.292 141.617 150.662 140.698 151.887 139.32C153.878 137.533 154.082 134.368 152.295 132.173C150.713 130.386 148.518 129.212 146.169 128.803C143.412 128.191 140.809 129.978 140.196 132.785C139.584 135.593 141.37 138.095 144.127 138.707Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M150.1 143.659C147.496 144.834 146.526 147.846 147.905 150.398C148.109 150.807 148.109 151.215 148.109 151.573C148.109 154.329 150.508 156.525 153.061 156.525C155.818 156.525 158.013 154.125 158.013 151.368C158.013 149.581 157.4 147.59 156.635 146.008C155.665 143.455 152.448 142.485 150.1 143.659Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.037 167.654C128.454 165.458 125.697 164.897 123.298 166.275C120.898 167.654 120.133 170.819 121.511 173.218C122.889 175.413 125.646 177.558 128.862 177.558C131.262 177.558 133.406 175.771 133.814 173.371C134.223 170.87 132.64 168.266 130.037 167.654Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.788 158.362C139.379 156.575 138.205 155.197 136.418 154.38C134.836 153.563 132.845 153.563 131.262 154.38C128.658 155.554 127.688 158.566 128.658 160.914C129.271 162.293 130.445 163.314 131.824 163.671C132.64 164.284 134.223 165.05 136.01 164.488C138.971 163.926 140.554 161.119 139.788 158.362Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.415 140.698C128.812 141.873 127.842 144.885 128.812 147.233C129.424 148.611 130.598 149.632 131.977 149.99C132.794 150.602 134.325 151.368 136.163 150.807C138.92 150.194 140.502 147.437 139.737 144.68C139.328 142.894 138.154 141.515 136.367 140.698C134.836 140.086 133.049 139.882 131.415 140.698Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.709 164.284C145.505 164.488 145.097 164.488 144.893 164.488C142.136 164.488 139.736 166.684 139.736 169.44C139.736 172.197 141.932 174.597 144.688 174.597H144.893C147.292 174.597 149.64 173.78 151.631 172.401C153.827 170.819 154.235 167.654 152.601 165.458C151.07 163.11 147.905 162.702 145.709 164.284Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.337 156.371C119.52 155.758 118.958 155.197 118.346 154.584C116.559 152.593 113.394 152.389 111.199 154.176C109.208 155.963 109.003 159.128 110.79 161.323C111.76 162.497 112.985 163.518 114.364 164.488C117.58 166.786 120.49 164.693 121.511 163.314C123.094 161.119 122.685 157.954 120.337 156.371Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M227.239 222.023L179.454 180.365C177.463 183.53 175.115 186.491 172.103 189.299C169.346 192.056 166.334 194.456 163.169 196.651L204.827 244.435C210.953 251.378 221.674 251.787 228.26 245.252C234.59 238.87 234.182 228.201 227.239 222.023Z",
    fill: "#6C6969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -4,
    y: 0,
    width: 258,
    height: 258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbc);
export default __webpack_public_path__ + "static/media/CBC.bb8ac987fe6e959766541d290885a20b.svg";
export { ForwardRef as ReactComponent };